import React from 'react';
import {
  DefiRessourcesDynamicZone,
  ComponentDefiDefiLiens,
  ComponentDefiDefiMedia
} from 'graphql/generated/graphql';
import { ExternalLink } from 'components/atoms/Links/ExternalLink';
import { mediaDir } from 'appolloConfig';
import useStyle from './linksList.style';

interface LinksListProps {
  ressources: DefiRessourcesDynamicZone[];
}

export const LinksList = ({ ressources }: LinksListProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      {ressources.map(
        (ressource: ComponentDefiDefiLiens, index) =>
          ressource.url !== (null || undefined) && (
            <ExternalLink
              variant="ressource"
              key={index}
              textInside={
                ressource.name ? ressource.name : `Ressource n°${index}`
              }
              link={ressource.url}
              color="#4824d5"
            />
          )
      )}
      {ressources.map((ressource: ComponentDefiDefiMedia, index) => {
        const media = ressource.media?.data[0]?.attributes;
        return (
          media !== (null || undefined) && (
            <ExternalLink
              variant="ressource"
              key={index}
              textInside={
                ressource.name ? ressource.name : `Ressource n°${index}`
              }
              link={media.url && mediaDir + media.url}
              color="#4824d5"
            />
          )
        );
      })}
    </div>
  );
};
